import { DEFAULT_CURRENCY } from '@constants/currency';

export const getLocationSelectNode = (locationSelectValue) => {
  if (locationSelectValue.id === 'all') {
    return locationSelectValue;
  }

  const locSelectNode = {
    facility_id: locationSelectValue.facilityId,
    facility_name: locationSelectValue.facility?.name || locationSelectValue.facilityName || '',
    id: locationSelectValue.id,
    name: locationSelectValue.name,
    currency: locationSelectValue.currency || locationSelectValue.facility?.currency || DEFAULT_CURRENCY,
    level_name: locationSelectValue.facilityId ? locationSelectValue.levelName || 'facility' : 'group',
    filterIds: locationSelectValue.filterIds,
  };

  return locSelectNode;
};
